export default Object.freeze({
  Radio: 1,
  Text: 2
});
